
import { Vue, Component, Prop } from 'nuxt-property-decorator';
import { SelectOption } from '../../services';
import { Countries, Provinces } from '../../core';
import FilterSelect from './FilterSelect.vue';
import { sortBy, omit, isEqual } from 'lodash-es';

@Component({
  components: {
    FilterSelect,
  },
})
export default class FilterCountryList extends Vue {
  @Prop({ type: String, required: true }) readonly fieldId!: string;
  @Prop({ type: String, required: true }) readonly fieldShortLabel!: string;

  get countryLabel() {
    return `${this.$t('shared.inputs.select.country_label')} - ${this.fieldShortLabel}`;
  }

  get provinceLabel() {
    return `${this.$t('shared.inputs.select.state_label')} - ${this.fieldShortLabel}`;
  }

  get countryOptions(): SelectOption[] {
    return sortBy(
      Countries.map(c => ({ id: c, label: this.$t(`shared.geo.countries.${c}`) })),
      'label',
    );
  }

  get provinceOptions(): SelectOption[] {
    const queryValue = this.$route.query[`countryRegions[${this.fieldId}]`];
    const provinces = Provinces.filter(x => x.country === queryValue).map(p => ({
      id: p.province,
      label: this.$t(`shared.geo.provinces.${p.province}`),
    }));
    return sortBy(provinces, 'label');
  }

  onCountryRegionChange(val, oldVal) {
    if (val === oldVal) return;
    const stateProvinceQueryKey = `stateProvinces[${this.fieldId}]`;
    if (this.provinceOptions.find(x => x.id === this.$route.query[stateProvinceQueryKey])) return;
    const query = omit({ ...this.$route.query }, ['page', stateProvinceQueryKey]);

    if (isEqual(query, this.$route.query)) return;
    this.$router.push({ query });
  }
}
